module.exports = "<section\n\t\tlayout=\"row\"\n\t\tlayout-align=\"center center\"\n\t\tlayout-fill>\n\t<div class=\"login-container\">\n\t\t<ui-view></ui-view>\n\t</div>\n</section>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./sources/components/auth/auth.html
// module id = 176
// module chunks = 0